import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  fuelCard: null,
  error: null,
  id: null,
  updateManageFuelCardResult: null,
  units: []
};

const route = "modules/manage/modals/editManageFuelCard/redux/slice";

export const manageEditManageFuelCard = createAsyncThunk(
  "manage/editManageFuelCard/editManageFuelCard",
  async (payload, { rejectWithValue }) => {
    try {
      const mutation = `
              mutation (
                  $id: Int!,
                  $unitId: Int
                  $driverId: Int
                  $tankSize: Float
              ) {
                  data: updateFuelCard (
                      id: $id,
                      unitId: $unitId
                      driverId: $driverId
                      tankSize: $tankSize
                  ) {
                      id
                  }
              }
          `;
      const response = await clientMutation(mutation, payload, endpoints.GRAPHQL_GENERAL_V2);
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageEditManageFuelCard");
      return rejectWithValue(exc);
    }
  }
);

const manageEditManageFuelCardRedux = createSlice({
  name: "manage/editManageFuelCard",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalEditManageFuelCard(state, action) {
      state.open = true;
      state.fuelCard = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageEditManageFuelCard
    builder.addCase(manageEditManageFuelCard.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageEditManageFuelCard.fulfilled, (state, action) => {
      state.loading = false;
      state.updateManageFuelCardResult = action.payload;
    });
    builder.addCase(manageEditManageFuelCard.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageEditManageFuelCardRedux;

// Extract and export each action creator by name
export const { reset, openModalEditManageFuelCard } = actions;

// Export the reducer, either as a default or named export
export default reducer;
